export default {
  // 数据新增千分符
  numFormat(num) {
    let firstStr = String(num).startsWith('-') ? String(num).slice(0, 1) : ''; // 判断这个数字是不是负数
    num = firstStr ? String(num).slice(1) : String(num); // 如果是负数就截取掉负数 再进行千分符的添加
    num = num.split('.'); // 分隔小数点
    let arr = num[0].split('').reverse(); // 转换成字符数组并且倒序排列
    let res = [];
    for (let i = 0, len = arr.length; i < len; i++) {
      if (i % 3 === 0 && i !== 0) {
        res.push(','); // 添加分隔符
      }
      res.push(arr[i]);
    }
    res.reverse(); // 再次倒序成为正确的顺序
    if (num[1]) {
      // 如果有小数的话添加小数部分
      res = res.join('').concat(`.${num[1]}`);
    } else {
      res = res.join('');
    }
    return firstStr ? `${firstStr}${res}` : res; // 判断如果有负号，最后再添加到首位
  },
  /**
   *强制转换成数字类型并且默认保留2位小数
   *
   * @export
   * @param {*} data 要处理的值
   * @param {number} [serve=2] 要保留的小数位，默认为2位
   * @returns 0.00
   */
  toNumTFixed(data, serve = 2) {
    return Number(data).toFixed(serve);
  },
  // 保留2位小数并补位
  toNumTFixedZero(data) {
    if (!isNaN(+data)) {
      let num = Math.round(data * 100) / 100;
      let str = num.toString();
      let rs = str.indexOf('.');
      if (rs < 0) {
        rs = str.length;
        str += '.';
      }
      while (str.length <= rs + 2) {
        str += '0';
      }
      return str;
    }
    return '0.00';
  },
};

export const payType = {
  wechat: '微信',
  alipay: '支付宝',
  bank: '银行卡',
  ecny: '数字人民币',
};
export const payTypeClass = {
  wechat: 'wechat',
  alipay: 'alipay',
  bank: 'bank',
  ecny: 'ecny',
};

// 流水交易类型
export const KmType = {
  1: '出售', // 出售挂单
  2: '购买', // 购买挂单
  3: '充币', // 充币
  4: '提币', // 提币
  5: '充值', //充值(出币方)
  6: '充值', //  充值(收币方)
  7: '下发', // 下发(出币方)
  8: '下发', // 下发(收币方)
  9: '提现', // 商户提现
  10: '转账', // 商户转账(入)
  11: '转账', // 商户转账(出)
  12: '转账', // 特殊转账(入)
  13: '转账', // 特殊转账(出)
  14: '兑换', // 币种兑换(入)
  15: '兑换', // 币种兑换(出)
};

// 验证类型
export const validationType = {
  google: '谷歌验证码',
  email: '邮箱',
  phone: '手机号',
};
